export default "__VITE_ASSET__BxpN$HdQ__"